import { SxProps } from '@mui/system';

export const TitlesMargin: SxProps = {
  marginLeft: { xs: '5px', sm: '5px', md: '10px', lg: '10px' },
  marginRight: { xs: '5px', sm: '5px', md: '10px', lg: '10px' },
  borderBottom: 1,
  borderColor: 'primary.main',
  position: 'sticky',
  top: 0,
};
